import { MultiStepWizard } from '../MultiStepWizard/MultiStepWizard'
import { MultiStepInstagramPlanningSchema } from '../schemas/InstagramPlanning'
import { MultiStepInstagramPlanningWizardProps } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ASPECT_RATIOS, DesignChannel } from 'components/NewFileModal/Types'
import { SelectCaptions } from '../PlanningWizard/SelectCaptions/SelectCaptions'
import { ChooseTopic } from '../PlanningWizard/ChooseTopic/ChooseTopic'
import { PlanContent } from '../PlanningWizard/PlanContent/PlanContent'
import { ContentPlanningProvider, useContentPlanningContext } from '../PlanningWizard/ContentPlanningContext'
import { useState } from 'react'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { MediaType } from '../schemas/shared/mediaType'

const MultiStepInstagramPlanningWizard = (
  props: MultiStepInstagramPlanningWizardProps & {
    mediaType: string
    setMediaType: (mediaType: MediaType) => void
  },
) => {
  const { generateCampaign } = useContentPlanningContext()
  const { width, height } = ASPECT_RATIOS['instagram-square-post']
  const { mediaType, setMediaType } = props

  return (
    <MultiStepWizard.Root
      {...props}
      schema={MultiStepInstagramPlanningSchema}
      onSubmit={generateCampaign}
      initialValues={{
        ...props.initialValues,
        media_type: mediaType,
        width,
        height,
        source_visual_element_ids: props.initialValues?.source_visual_element_ids || [],
      }}
    >
      <ChooseTopic
        header="Enter a Topic for Your Instagram Posts"
        subHeader="Blaze will help you write and schedule a cluster of content around this topic linked to a Blaze campaign for easy reference."
        onChange={(values) => setMediaType(values.media_type)}
      />
      <SelectCaptions
        header="Select Instagram Captions"
        subHeader="Select captions related to your topic. You can edit them directly on this page."
        inputPlaceholder="Write your own caption..."
        nextLabel={() => 'Plan'}
      />
      <PlanContent
        header="Plan Your Instagram Calendar"
        subHeader="Select a date and time for each of your posts or have Blaze pick for you."
        externalIntegrationType={ExternalIntegrationEnum.Instagram}
        previousLabel={mediaType === 'design' ? 'Templates' : 'Captions'}
      />
    </MultiStepWizard.Root>
  )
}

const MultiStepInstagramPlanningWizardContainer = (props: MultiStepInstagramPlanningWizardProps) => {
  const targetWriter = useFlipperFlag('writer_multiplanning')
  const [mediaType, setMediaType] = useState(
    props.initialValues?.media_type || (targetWriter ? MediaType.DocumentWithImages : MediaType.Design),
  )
  return (
    <ContentPlanningProvider
      captionsGenerationType={ChannelType.InstagramPosts}
      generationType={mediaType === MediaType.Design ? DesignChannel.InstagramPost : ChannelType.InstagramPosts}
      initialValues={props.initialValues}
    >
      <MultiStepInstagramPlanningWizard {...props} mediaType={mediaType} setMediaType={setMediaType} />
    </ContentPlanningProvider>
  )
}

export { MultiStepInstagramPlanningWizardContainer as MultiStepInstagramPlanningWizard }
